'use strict'

import clientHTML from './clientHTML.js';

const serverApi = new clientHTML();

export default serverApi; 
